import styled, { css } from "styled-components/macro"

export const RadioWrap = styled.div`
  ${p =>
    p.inline &&
    css`
      display: flex;
    `};
`
